export {default} from './ClosingHeader';
